module.exports = __webpack_public_path__ + "img/food-4.47aeef13.jpg";